import request from '../utils/request';
import { API_ENDPOINTS } from '../config/api';

export const authAPI = {
  login: (data) => {
    return request.post(API_ENDPOINTS.LOGIN, data);
  },
  getCurrentAdmin: () => {
    return request.get(API_ENDPOINTS.CURRENT_ADMIN);
  },
  changePassword: (data) => {
    return request.put(API_ENDPOINTS.CHANGE_PASSWORD, data);
  }
};
